import React, {Component} from 'react'

import FormModel from 'models/FormModel'

import Input from 'ui/Input'
import FormInput from 'ui/FormInput'
import FormSelect from 'ui/FormSelect'
import FormLegend from 'ui/FormLegend'
import FormTextarea from 'ui/FormTextarea'
import FormCheckbox from 'ui/FormCheckbox';
import FormTagger from './FormTagger';

class Form extends Component{

  constructor(props){
    super(props)
    this.state = {
      errors: []
    }
    this.formModel = null
  }

  componentDidMount(){
    this.setState(this.props.formData || this.state)
    this.setFormState()
  }

  componentDidUpdate(prevProps){
    if(prevProps.data !== this.props.data){
      this.setFormState()
    }
  }

  setFormState(){
    for(let elem of FormModel[this.props.classname].form){
      if(elem.field){
        this.setState({[elem.field]:this.props.data ? this.props.data[elem.field] : ''})
      }
    }
  }

  handleChange(e) {
    const {
      errors
    } = this.state

    let errorArray = [...errors]
    const name = e.target.name

    errorArray = errorArray.filter(error => error !== name)

    let value
    if(e.target.type === 'checkbox'){
      value = e.target.checked
    } else {
      value = e.target.value
    }
    this.setState({
      [name]: value,
      errors: errorArray
    });
  }

  submitForm(e){
    const {
      classname,
    } = this.props

    let errorArray = []

    e.preventDefault()

    FormModel[classname].form.map((elem) => {
      if (elem.required) {
        // If an form entry is required, check it has a value
        if (!this.state[elem.name]) {
          errorArray.push(elem.name)
        }
        // Check the entry for the phone number is valid
        if (this.state['contactNumber'] && !this.state['contactNumber'].match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g)) {
          errorArray.push(elem.name)
        }
      }
      if(elem.isPassword){
        //if not filled out
        if(!this.state[elem.name]){
          errorArray.push(elem.name)
        }
        //check password confirm is the same
        if(this.state[elem.name] !== this.state[elem.confirm]){
          errorArray.push(elem.confirm)
        }
      }
    })

    if (errorArray.length === 0) {
      this.props.submit(this.state)
    } else {
      this.setState({
        errors: errorArray
      })
    }
  }

  getFormElements(){
    const formElem = FormModel[this.props.classname].form.map((elem,index)=>{
      switch(elem.elem){
        case 'input':
          if(this.props.altInput){
            return <Input
              type={elem.type}
              key={index}
              name={elem.name}
              value={this.state[elem.name] || ''}
              change={(e)=>this.handleChange(e)}
              classname={this.props.classname}
              label={elem.label}/>
          } else {
            //for enable/disable input
            const disabled = elem.enabledBy ? (this.state[elem.enabledBy] ? false : true) : elem.disabled
            return <FormInput
              type={elem.type}
              key={index}
              name={elem.name}
              value={this.state[elem.name] || ''}
              change={(e)=>this.handleChange(e)}
              classname={this.props.classname}
              label={elem.label}
              required={elem.required}
              hasError={this.state.errors.find(error=>error === elem.name) || (this.props.serverError && this.props.serverError.data === elem.name)}
              serverError={this.props.serverError}
              disabled={disabled}/>
          }
          case 'legend':
            return <FormLegend key={index} label={elem.label}/>
          case 'select':
            return <FormSelect
              key={index}
              name={elem.name}
              classname={this.props.classname}
              selected={this.state[elem.name]}
              options={this.props[elem.optionsProp]}
              action={(e)=>this.handleChange(e)}
              label={elem.label}/>
          case 'textarea':
            return <FormTextarea
              key={index}
              name={elem.name}
              value={this.state[elem.name] || ''}
              change={(e)=>this.handleChange(e)}
              classname={this.props.classname}
              label={elem.label}
              autocomplete="no"/>
          case 'tagger':
            return <FormTagger
              key={index}
              classname={this.props.classname}
              placeholder={elem.placeholder}
              display={elem.display}
              data={this.props.data[elem.data]}
              allData={this.props.data[elem.allData]}
              />
          case 'checkbox':
            return <FormCheckbox
              key={index}
              name={elem.name}
              change={(e)=>this.handleChange(e)}
              classname={this.props.classname}
              label={elem.label}              
              />
      }
    })
    return formElem
  }

  render(){
    const {classname, message, scroll} = this.props
    const classes = `form form-${classname} ${scroll ? 'scroll' : ''}`
    return (
      <form className={classes} onSubmit={(e)=>this.submitForm(e)}>
        {this.getFormElements()}
        <span className={`form-message form-message-${classname}`}>
          {message}
        </span>
        <button type="submit" className={`form-submit form-submit-${classname}`}>
          {FormModel[classname].submitLabel}
        </button>
      </form>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/ui/Form.js